// extracted by mini-css-extract-plugin
export default {"container":"P1-z"};